import { Link } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

interface ReviewAskProps {
  dismissRatingSteps: () => void;
  game: { id: string; myEscape?: { id: string } };
}

export default function ReviewAsk({
  game,
  dismissRatingSteps,
}: ReviewAskProps) {
  return (
    <div className="flex flex-col text-center">
      <p className="mb-2.5 font-semibold">Thanks! Want to add details?</p>
      <p className="text-pale-lavender">
        You can tag friends, log your experiences, and more.
      </p>
      {game.myEscape && (
        <Button
          asChild
          className="my-6 h-9.5 w-full rounded-[19px] shadow-0-0-10 shadow-fandango/60"
          variant="cta"
        >
          <Link to={`/experience/${game.id}/${game.myEscape.id}`}>
            Add more details
          </Link>
        </Button>
      )}
      <Button
        className="cursor-pointer text-14 text-white hover:underline"
        onClick={dismissRatingSteps}
        variant="link"
      >
        Not now, thx!
      </Button>
    </div>
  );
}
